export default {
  title: 'Come ti piace {{name}}?',
  description: 'Il tuo feedback è anonimo e ci aiuta a migliorare.',
  upload_google_review: {
    title: 'Lascia una recensione e ottieni premi',
  },
};
